export enum Access {
  ADMIN = 1,
  COUNTRY_MANAGER = 2,
  CUSTOMER = 3,
  CUSTOMERDASHBOARD = 5,
}
